'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DropDownMenu = require('./DropDownMenu');

var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DropDownMenu2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/lib/DropDownMenu/index.js
// module id = 223
// module chunks = 0